import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useCoverEditorTour } from 'sections/Dashboard/features/CoverEditor/hooks/useTour'
import { useDashTour } from 'sections/Dashboard/hooks'
import { DashboardHelpContainer } from './style'

function DashboardHelp() {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const launchDashTour = useDashTour()
  const launchCoverTour = useCoverEditorTour()

  const isOnCoverEditor = pathname.includes('cover-design') ? true : false

  return (
    <DashboardHelpContainer>
      <h4
        className="mr-3 cursor"
        onClick={isOnCoverEditor ? launchCoverTour : launchDashTour}
      >
        {t('dashboard_tour_btn')}
      </h4>
    </DashboardHelpContainer>
  )
}

export default DashboardHelp
